export const CREATE_SUPPLIER = 'CREATE_SUPPLIER';
export const READ_SUPPLIER = 'READ_SUPPLIER';
export const UPDATE_SUPPLIER = 'UPDATE_SUPPLIER';
export const DELETE_SUPPLIER = 'DELETE_SUPPLIER';
export const GET_PRODUCT_FOR_SUPPLIER = 'GET_PRODUCT_FOR_SUPPLIER';
export const GET_PRODUCT_BY_ID_FOR_SUPPLIER = 'GET_PRODUCT_BY_ID_FOR_SUPPLIER';
export const CREATE_PRODUCT_BY_SUPPLIER = 'CREATE_PRODUCT_BY_SUPPLIER';
export const DELETE_PRODUCT_BY_SUPPLIER = 'DELETE_PRODUCT_BY_SUPPLIER';
export const UPDATE_PRODUCT_BY_SUPPLIER = 'UPDATE_PRODUCT_BY_SUPPLIER';
